import { AgxBodyText, AgxColumn, AgxHeader, formatPercentage } from '@urbanx/agx-ui-components';
import clsx from 'clsx';
import {
  ExecutiveRunRateMetricsResponse,
  RunRateMetric,
} from 'services/functions/rex/reporting/useExecutiveRunRateMetrics';
import formatMetricsValue from './formatMetricsValue';

interface TableRunRateProps {
  runRateData: ExecutiveRunRateMetricsResponse | undefined;
}

const RunRateMetricRow = ({ metric }: { metric: RunRateMetric }) => {
  const { title, monthToDate, runRate, previousYearMonthToDate, percentageChange, metricType } =
    metric;

  return (
    <div className="breakeven-table-row">
      <AgxBodyText medium extraClasses="breakeven-cell left strong">
        {title}
      </AgxBodyText>
      <AgxBodyText extraClasses="breakeven-cell strong">
        {formatMetricsValue(monthToDate, metricType)}
      </AgxBodyText>
      <AgxBodyText extraClasses="breakeven-cell">
        {formatMetricsValue(runRate, metricType)}
      </AgxBodyText>
      <AgxBodyText extraClasses="breakeven-cell">
        {formatMetricsValue(previousYearMonthToDate, metricType)}
      </AgxBodyText>
      <AgxBodyText
        extraClasses={clsx(
          'breakeven-cell',
          'strong',
          percentageChange >= 0 ? 'positive' : 'negative'
        )}
      >
        {formatPercentage(percentageChange.toString(), 2)}
      </AgxBodyText>
    </div>
  );
};

const TableRunRate = ({ runRateData }: TableRunRateProps) => {
  const { period, previousYearPeriod, metrics } = runRateData || {};

  if (!runRateData) return;

  return (
    <AgxColumn extraClasses="metrics-data">
      <AgxColumn>
        <AgxHeader size={3}>Run Rate</AgxHeader>
        <AgxBodyText medium>{period}</AgxBodyText>
      </AgxColumn>
      <div className="breakeven-table">
        <div className="breakeven-table-header">
          <AgxBodyText extraClasses="breakeven-blank">.</AgxBodyText>
          <AgxBodyText extraClasses="breakeven-header">MTD</AgxBodyText>
          <AgxBodyText extraClasses="breakeven-header">Run Rate</AgxBodyText>
          <AgxBodyText extraClasses="breakeven-header">
            {previousYearPeriod || 'No data'}
          </AgxBodyText>
          <AgxBodyText extraClasses="breakeven-header">Change %</AgxBodyText>
        </div>
        {metrics?.map((row, index) => (
          <RunRateMetricRow key={index} metric={row} />
        ))}
      </div>
    </AgxColumn>
  );
};

export default TableRunRate;
